
import { useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function StatsBar() {
  const stats = [
    { value: '70%', label: 'Avg. Ticket Reduction', icon: 'ri-arrow-down-circle-line' },
    { value: '4s', label: 'Avg. Response Time', icon: 'ri-timer-flash-line' },
    { value: '24/7', label: 'Always-On Coverage', icon: 'ri-time-line' },
    { value: '0', label: 'Additional Headcount', icon: 'ri-team-line' },
  ];

  const { ref, getItemStyle } = useStaggerAnimation(stats.length);

  return (
    <section className="bg-[#F9F8F6] py-10 md:py-14 border-y border-[#E8E4DC]">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8" ref={ref}>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center" style={getItemStyle(index)}>
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-[#B8985F] text-xl`}></i>
              </div>
              <p className="text-[26px] md:text-[32px] font-bold text-[#1A1A1A] mb-1">{stat.value}</p>
              <p className="text-[13px] md:text-[14px] text-[#777] font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
